import { Styles, css, extractShadow, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    padding: 0 16px 16px 16px;

    min-width: 400px;

    overflow: hidden;
  `,
  container: ({ theme }) => css`
    display: flex;
    width: 100%;
    height: 100%;
    min-width: 0;
    flex-direction: column;
    z-index: 0;
    gap: 12px;

    background-color: ${theme.colors.neutral.variant[0]};
    border: 1px solid ${theme.colors.neutral.variant[10]};
    border-radius: 14px;

    box-shadow: ${extractShadow((s) => s.robin2)};
  `,
  tabs: css`
    height: 100%;
    padding: 0 12px;
    min-height: 0;
  `,
  tabButton: css`
    display: flex;
    padding: 6px 12px;
    height: auto;
    flex-grow: unset;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  `,
  tabContent: ({ theme }) => css`
    display: flex;
    padding: 12px 0 16px;
    background-color: ${theme.colors.neutral.variant[0]};
    height: 100%;
    overflow: hidden;
  `,
  tabContentHistory: css`
    padding-right: 0;
  `,
  addLabels: css`
    display: flex;
    margin-left: auto;
    align-items: center;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
